//import http from "../http";

const AppHeaderService = {

    GetNewNotifiesByLastId: async (LastId) => {
            console.log("service lastid: "+LastId);
            //const Notifies = await http.instance.get("/Notify/GetNewNotifiesByLastId", {params: {LastId: LastId}});
            //console.log("notifies");
            //console.log(Notifies.data);
            return [];
    },

    GetNotifiesOfSummary: async (SummaryId) => {
        console.log("Service SummaryId :"+ SummaryId);
        //const Notifies = await http.instance.get("/Notify/GetNewNotifiesByLastId", {params: {LastId: LastId}});
        //console.log("details:");
        //console.log(Notifies.data);
        return [];
    },

};
export default AppHeaderService;

